import { render, staticRenderFns } from "./MunicipalityInput.vue?vue&type=template&id=50463474&lang=pug"
import script from "./MunicipalityInput.vue?vue&type=script&lang=js"
export * from "./MunicipalityInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports